
import { defineComponent, onMounted, onBeforeUnmount, Ref, ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import { useRouter, useRoute } from "vue-router";
import { Modal } from "bootstrap";
import axios from "axios";
import useAlert from "@/composables/Alert";
import Title from "@/components/Title.vue"
import Button from "@/components/Button.vue"
import Api from "@/services/Api";
import Pagination from "@/components/Pagination.vue";
import useEmitter from "@/composables/Emmiter";
import ModalEditarFiltro from "./components/ModalEditarFiltro.vue";
import ModalAdicionarFiltro from "./components/ModalAdicionarFiltro.vue";
import { ElSkeleton, ElSkeletonItem } from 'element-plus'

export default defineComponent({
  name: "FiltroLubrificantes",
  components: {
    Title,
    Button,
    Pagination,
    ModalEditarFiltro,
    ModalAdicionarFiltro,
    ElSkeleton,
    ElSkeletonItem  
  },
  emits: ["alterarExibicao"],
  setup() {
    const page: Ref<number> = ref(1)
    const limit: Ref<number> = ref(10)
    const filtro: Ref<any> = ref({ marca: null, tipo: null, filtro: null });
      
    const auxModal: any = ref();

    const { showTimeAlert } = useAlert();

    const loading = ref(false);
    const loadSalvar: Ref<boolean> = ref(false);
    const loadExcluir: Ref<boolean> = ref(false);
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const spanWarning = ref(false);
    const spanWarningEdit = ref(false);
    const buscaFiltro = ref(false);
    const totalFiltros: Ref<number> = ref(0);
    const filtros: Ref<any> = ref([]);
    const filtroClicked: Ref<any> = ref([]);
    const tiposDeFiltro: Ref<any> = ref([]);
    const tipo = ref("");
    const nome = ref("");
    const marcasDeFiltro: Ref<any> = ref([]);
    const pagination = ref<InstanceType<typeof Pagination> | null>(null);
    const skeleton = ref(true)
    const filtroUnico: any = ref({
      id_filtro: null,
      marca: "",
      nome: "",
      tipo: "",
      descricao: "",
      ean: "",
      status: "",
      imagem: ""
    });

    //Emitter para filtrar os itens do modal do cabeçalho
    const emitter = useEmitter();
    emitter.on("paramsFilter", (payload: any) => {
      // payload.paramsFilter vem do componente do header.
      // Se os nomes de campos forem os mesmos, faz merge direto:
      filtro.value = { ...filtro.value, ...payload.paramsFilter };

      // se for necessário mapear campos diferentes, faça aqui a transformação:
      // ex: if (payload.paramsFilter.nomeFantasia) filtro.value.produto = payload.paramsFilter.nomeFantasia

      // resetar paginação e refazer a busca
      page.value = 1;
      pagination.value?.resetPage?.(1);

      buscaFiltro.value = false
      allFiltros();
    });

    function handleImgFileChange(event: Event, target: "filtroUnico" | "filtroClicked" = "filtroUnico") {
      const fileInput = event.target as HTMLInputElement;
      const file = fileInput.files?.[0];
      if (!file) return;

      if (target === "filtroUnico") {
        filtroUnico.value.imagem = file;
        // opcional: se quiser mostrar preview no modal de criação, use filtroUnico.value.imagemPreview
      } else {
        // edição
        filtroClicked.value.imagem = file;
      }
    }

    //FUNCAO PARA PEGAR O TOKEN
    const getToken = async () => {
      return localStorage.getItem("token_usuario");
    };

    async function allFiltros() {
      try {
        skeleton.value = true; // Inicia o skeleton
        const res = await axios.get("getAllFiltrosPaginado", {
          params: {
            pagina: page.value,
            limite: limit.value,
            ...filtro.value
          },
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        });

        const retorno = res.data.data;
        filtros.value = retorno.filtros;
        totalFiltros.value = retorno.totalFiltros; 
        
        buscaFiltro.value = filtros.value.length === 0;

      } catch (err) {
        console.error("Erro ao buscar filtros:", err);
        showTimeAlert("Erro ao carregar dados", "error");
      } finally {
        // Isso garante que o skeleton pare de exibir idependente de sucesso ou erro
        skeleton.value = false; 
      }
    }

    async function getMarcasProduto(){
      loading.value = true
      try{
        const { data } = await Api.get("getMarcasProdutoDbInfo", {tipoProduto: 'filtros'});
        if(data.length === 0) {
          showTimeAlert("Não foi possivel obter as marcas dos produtos", "error");
        } else {
          marcasDeFiltro.value = data;
        }
      }catch(err){
        showTimeAlert("Não foi possivel obter as marcas dos produtos", "error");
        console.log(err);
        loading.value = false
      }finally{
        loading.value = false
      }
    }

    async function getTipoProdutoFiltros(){
      loading.value = true
      try{
        const { data } = await Api.get("getTipoProdutoFiltros");
        if(data.length === 0) {
          showTimeAlert("Não foi possivel obter as marcas dos produtos", "error");
        } else {
          tiposDeFiltro.value = data;
        }
      }catch(err){
        showTimeAlert("Não foi possivel obter as marcas dos produtos", "error");
        console.log(err);
        loading.value = false
      }finally{
        loading.value = false
      }
    }

    const onAddFiltroFinish = async (payload: any) => {
      if (payload?.success) {
        // limpeza: remover o arquivo do form local
        filtroUnico.value.imagem = "";

        if (filtroUnico.value.length) {
          filtroUnico.value = [];
        }

        showTimeAlert("Filtro adicionado com sucesso!");
        await allFiltros();
      } else {
        showTimeAlert("Não foi possivel adicionar o filtro.", "error");
      }
    };

    const onEditFiltroFinish = async (payload: any) => {
      if (payload?.success) {
        // limpeza: remover o arquivo do form local
        filtroUnico.value.imagem = "";

        if (filtroUnico.value.length) {
          filtroUnico.value = [];
        }

        showTimeAlert("Filtro atualizado com sucesso!");
        await allFiltros();
      } else {
        showTimeAlert("Não foi possivel atualizar o filtro.", "error");
      }
    };

    if (emitter && emitter.on) {
      emitter.on("addFiltro:finish", onAddFiltroFinish);
      emitter.on("editFiltro:finish", onEditFiltroFinish);
    }

    // remove listeners ao desmontar o componente
    onBeforeUnmount(() => {
      if (emitter && emitter.off) {
        emitter.off("addFiltro:finish", onAddFiltroFinish);
        emitter.off("editFiltro:finish", onEditFiltroFinish);
      }
    });

    function clickFiltro(clicked) {
      filtroClicked.value = clicked;
    }

    async function deleteFiltro(clicked) {
      loadExcluir.value = true;
      try {
        const res = await axios.post("deletaFiltro", clicked, {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        });
        filtros.value = filtros.value.filter(f => f.id !== clicked.id);
        allFiltros();
        showTimeAlert("Produto deletado com sucesso!");
        auxModal.value.hide(); // Fecha o modal após o alerta
      } catch (err) {
        showTimeAlert("Não foi possivel deletar o produto.", "error");
        auxModal.value.hide(); // Fecha o modal mesmo em caso de erro
      } finally {
        loadExcluir.value = false;
      }
    }

    const openModal = id => {
      const auxElement = document.querySelector(`#${id}`);
      auxModal.value = new Modal(auxElement);
      auxModal.value.show();
    };

    function handlePageChange(pageParam) {
      page.value = pageParam;
      allFiltros();
    }

    /* MODAL ADICIONAR FILTRO */
    function abrirModalAddFiltro() {
      ModalAdicionarFiltro.value.show()
    }

    function fechaModalAddFiltro() {
      ModalAdicionarFiltro.value.hide()
    }
    /* MODAL ADICIONAR FILTRO*/


    /* MODAL EDITAR FILTRO */  
    function abrirModalEditFiltro(item) {
      filtroClicked.value = item;
      // envia dados para o componente filho via emitter
      emitter.emit("openEditFiltro", { filtro: item });
      ModalEditarFiltro.value.show();
    }

    function fechaModalEditFiltro() {
      ModalEditarFiltro.value.hide();
    }
    /* MODAL EDITAR LUBRIFICANTE */

    watch(
      () => filtro.value,
      () => {
        page.value = 1;
        if (pagination.value) {
              pagination.value.resetPage(1);
            }
            allFiltros()
      }, {deep: true}
    )

    onMounted(() => {
      store.dispatch(Actions.ADD_BODY_CLASSNAME, "bg-body");
      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "bg-body");
      getMarcasProduto();
      getTipoProdutoFiltros();
      getToken();
      allFiltros();
      ModalEditarFiltro.value = new Modal(document.querySelector(`#ModalEditarFiltro`));
      ModalAdicionarFiltro.value = new Modal(document.querySelector(`#ModalAdicionarFiltro`));
    });
    
    return {
      spanWarning,
      spanWarningEdit,
      loading,
      abrirModalEditFiltro,
      abrirModalAddFiltro,
      fechaModalEditFiltro,
      fechaModalAddFiltro,
      tipo,
      nome,
      history,
      openModal,
      filtroClicked,
      deleteFiltro,
      buscaFiltro,
      marcasDeFiltro,
      router,
      route,
      handlePageChange,
      pagination,
      skeleton,
      handleImgFileChange,
      loadSalvar,
      loadExcluir,
      filtros,
      totalFiltros,
      tiposDeFiltro,
      clickFiltro,
      allFiltros
    };
  },
});
